import React from 'react';
import { Users, Settings } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../components/ui/table';

export const ClientAssignmentsTable = ({ clients, getClientTypeName, onChangeType }) => (
  <Card>
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <Users className="h-5 w-5 text-amber-500" />
        Client Type Assignments
      </CardTitle>
      <CardDescription>Assign pricing tiers to individual clients</CardDescription>
    </CardHeader>
    <CardContent>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Company</TableHead>
            <TableHead>Contact</TableHead>
            <TableHead>Current Type</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {clients.map((client) => (
            <TableRow key={client.id}>
              <TableCell className="font-medium">{client.company_name}</TableCell>
              <TableCell>{client.primary_contact_name}</TableCell>
              <TableCell>
                <Badge variant={client.client_type_id ? 'default' : 'secondary'}>
                  {getClientTypeName(client.client_type_id)}
                </Badge>
              </TableCell>
              <TableCell>
                <Badge className={client.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}>
                  {client.status}
                </Badge>
              </TableCell>
              <TableCell className="text-right">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onChangeType(client)}
                  data-testid={`change-client-type-${client.id}`}
                >
                  <Settings className="h-4 w-4 mr-1" />
                  Change Type
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </CardContent>
  </Card>
);
